import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { ProjectComplete } from "../../types/model/project";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project/projects/complete`;

export const getProjectsComplete = async (): Promise<ProjectComplete[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .get<ProjectComplete[]>(BASE_URL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return [];
    });
};
